import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { WikiNamespaces, WikiObject } from './types';

export type SaveWikiRequest = {
   namespace: WikiNamespaces;
   title: string;
   revisionid: number;
   fields: {
      major_approval_processid?: number | null;
      minor_approval_processid?: number | null;
      default_child_major_approval_processid?: number | null;
      default_child_minor_approval_processid?: number | null;
   };
   common: CommonRequestOptions;
};

export async function saveWiki({
   namespace,
   title,
   revisionid,
   fields,
   common = {},
}: SaveWikiRequest): Promise<WikiObject> {
   const body: Record<string, number | null> = {};
   if (fields.major_approval_processid !== undefined)
      body.major_release_approval_processid = fields.major_approval_processid;
   if (fields.minor_approval_processid !== undefined)
      body.minor_release_approval_processid = fields.minor_approval_processid;
   if (fields.default_child_major_approval_processid !== undefined)
      body.default_child_major_approval_processid = fields.default_child_major_approval_processid;
   if (fields.default_child_minor_approval_processid !== undefined)
      body.default_child_minor_approval_processid = fields.default_child_minor_approval_processid;

   return makeRequest('patch', `wikis/${namespace}/${title}`, {
      ...common,
      query: {
         revisionid,
      },
      body,
   });
}
